import { CheckGroupType } from './types';
import { VHCRecordItemGroups } from 'api/generated';

export const checkGroups: CheckGroupType[] = [
  {
    groupId: VHCRecordItemGroups.ExternalOrDriveIn,
    title: 'External / Drive In',
    statusCount: { ok: 0, warning: 0, notOk: 0 },
    items: []
  },
  {
    groupId: VHCRecordItemGroups.Internal,
    title: 'Internal',
    statusCount: { ok: 0, warning: 0, notOk: 0 },
    items: []
  },
  {
    groupId: VHCRecordItemGroups.UnderBonnet,
    title: 'Under Bonnet',
    statusCount: { ok: 0, warning: 0, notOk: 0 },
    items: []
  },
  {
    groupId: VHCRecordItemGroups.Underside,
    title: 'Underside',
    statusCount: { ok: 0, warning: 0, notOk: 0 },
    items: []
  },
  {
    groupId: VHCRecordItemGroups.BrakesAndHubs,
    title: 'Brakes & Hubs',
    statusCount: { ok: 0, warning: 0, notOk: 0 },
    items: []
  },
  {
    groupId: VHCRecordItemGroups.WheelsAndTyres,
    title: 'Wheels & Tyres',
    statusCount: { ok: 0, warning: 0, notOk: 0 },
    items: []
  }
];
